import React from "react";
import { DatePicker } from "antd";
export default ({
  value,
  field,
  onChange,
  placeholder,
  opts = {},
  disabled = false
}) => (
  <DatePicker
    format="YYYY-MM-DD"
    style={{ width: "100%" }}
    value={value}
    placeholder={placeholder || "请选择"}
    onChange={onChange}
    name={field}
    disabled={disabled}
    {...opts}
  />
);
